import { network } from 'services/network';

export const ENDPOINT = 'api/bo/getTopStartDateChanges';

export const getStartDateChangesTableData = (params) => {
    return network.post(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
